// // // Navbar.jsx

import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './styles.css'; 
import './index.css'; 
import './App.css'; 
import logoImage from './images/logow.png';
import logoHoverImage from './images/logoc.png'; 
import { controls } from './controls';

const Navbar = () => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();


  // const handleLogoClick = (e) => {
  //   e.preventDefault(); 
  //   // Check if you are already on the home page
  //   if (window.location.pathname === '/') {
  //     // Reload the scene using the 'r' key functionality
  //     controls["r"] = true;

  //   } else {
  //     // Navigate to the home page if not already on it
  //     navigate('/');
  //   }
  // }; 


  const handleLogoClick = (e) => {
    e.preventDefault();
    // Check if you are already on the home page
    if (window.location.pathname === '/') {
      // Reload the scene by refreshing the page
      window.location.reload();
    } else {
      // Navigate to the home page if not already on it
      navigate('/');
    }
  };


  const handleLogoTouch = (e) => {
    e.preventDefault(); 
    // Check if you are already on the home page
    if (window.location.pathname === '/') {
      // Reload the scene using the 'r' key functionality
      controls["r"] = true;

    } else {
      // Navigate to the home page if not already on it
      navigate('/');
    }
  }; 


  const handleNavbarTouch = (event, path) => {
    // Prevent default touch event behavior
    event.preventDefault();
    
    // Navigate to the specified path
    navigate(path);
  };

  return (
    <header className='header' style={{ zIndex: 100 }}>
      <NavLink>
        {/* placeholder */}
      </NavLink>
      <nav
        className='flex text-lg gap-7 font-medium'
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Active: text-blue-600 */}
        <NavLink to='/projects' onTouchStart={(event) => handleNavbarTouch(event, '/projects')} className={({ isActive }) => isActive ? "text-blue-600" : "text-white" }>
          Projects
        </NavLink>
        <NavLink to='/about' onTouchStart={(event) => handleNavbarTouch(event, '/about')} className={({ isActive }) => isActive ? "text-blue-600" : "text-white"}>
          About
        </NavLink>
        <NavLink to='/' onTouchStart={(event) => handleLogoTouch(event, '/')} onClick={handleLogoClick} className='ml-auto'>
          <img
            src={isHovered ? logoHoverImage : logoImage}
            alt='Logo'
            className='w-10 h-10 object-contain'
            style={{ marginTop: '-5px' }}
            // onTouchStart={handleLogoTouch}   // onTouchStart={(event) => handleNavbarTouch(event, '/')}
          />
        </NavLink>
      </nav>
    </header>
  );
};

export default Navbar;

















// // // // Navbar.jsx

// import React, { useState } from 'react';
// import { NavLink, useNavigate } from 'react-router-dom';
// import './styles.css'; 
// import './index.css'; 
// import './App.css'; 
// import logoImage from './images/logow.png';
// import logoHoverImage from './images/logoc.png'; 
// import { controls } from './controls';

// const Navbar = () => {
//   const [isHovered, setIsHovered] = useState(false);
//   const navigate = useNavigate();


//   // const handleLogoClick = (e) => {
//   //   e.preventDefault(); 
//   //   // Check if you are already on the home page
//   //   if (window.location.pathname === '/') {
//   //     // Reload the scene using the 'r' key functionality
//   //     controls["r"] = true;

//   //   } else {
//   //     // Navigate to the home page if not already on it
//   //     navigate('/');
//   //   }
//   // }; 


//   const handleLogoClick = (e) => {
//     e.preventDefault();
//     // Check if you are already on the home page
//     if (window.location.pathname === '/') {
//       // Reload the scene by refreshing the page
//       window.location.reload();
//     } else {
//       // Navigate to the home page if not already on it
//       navigate('/');
//     }
//   };


//   const handleLogoTouch = (e) => {
//     e.preventDefault(); 
//     // Check if you are already on the home page
//     if (window.location.pathname === '/') {
//       // Reload the scene using the 'r' key functionality
//       controls["r"] = true;

//     } else {
//       // Navigate to the home page if not already on it
//       navigate('/');
//     }
//   }; 


//   const handleNavbarTouch = (event, path) => {
//     // Prevent default touch event behavior
//     event.preventDefault();
    
//     // Navigate to the specified path
//     navigate(path);
//   };

//   return (
//     <header className='header' style={{ zIndex: 100 }}>
//       <NavLink>
//         {/* placeholder */}
//       </NavLink>
//       <nav
//         className='flex text-lg gap-7 font-medium'
//         onMouseEnter={() => setIsHovered(true)}
//         onMouseLeave={() => setIsHovered(false)}
//       >
//         {/* Active: text-blue-600 */}
//         <NavLink to='/projects' onTouchStart={(event) => handleNavbarTouch(event, '/projects')} className={({ isActive }) => isActive ? "text-blue-600" : "text-white" }>
//           Projects
//         </NavLink>
//         <NavLink to='/about' onTouchStart={(event) => handleNavbarTouch(event, '/about')} className={({ isActive }) => isActive ? "text-blue-600" : "text-white"}>
//           About
//         </NavLink>
//         <NavLink to='/' onTouchStart={(event) => handleNavbarTouch(event, '/')} onClick={handleLogoClick} className='ml-auto'>
//           <img
//             src={isHovered ? logoHoverImage : logoImage}
//             alt='Logo'
//             className='w-10 h-10 object-contain'
//             style={{ marginTop: '-5px' }}
//             onClick={handleLogoClick} // Add onClick handler to the logo image ("r") NEW
//             onTouchStart={handleLogoTouch}
//             // onTouchEnd={handleLogoClick}
//           />
//         </NavLink>
//       </nav>
//     </header>
//   );
// };

// export default Navbar;